import { object, string, number } from "yup"
import { ID2 } from "./yup.common"

export default object({
  amount: number().positive("Amount should be greater than 0!"),
  contractId: ID2("Contract"),
  name: string(),
  paidToId: ID2("Owner / Driver").required(
    "Owner / Driver is required! (paid to)"
  ),
  paymentFor: ID2("Vehicle").required("Vehicle is required!"),
  paymentTypeId: ID2("Payment Type").required("Payment Type is required!"),
  remark: string(),
  transactionType: string().required("Payment Method is required!"),
})
